import { ChevronDown as ExpandMore } from 'lucide-react';

import agent from '@root/agent';
import successCheckMark from '@root/assets/img/auth/mail-sent-checkmark.svg';
import NoData from '@root/components/common/NoData';
import HeaderBarNew from '@root/components/HeaderBarNew';
// import TableSkeleton from '@root/components/table/skeleton';
import MuiTable from '@root/components/table/table';
// import CloudProviderBar from '@root/components/v2/content/CloudProviderBar';
import { useCloudProvider } from '@root/components/v2/content/CloudProviderBar/CloudProviderContext';
import Breadcrumbs from '@root/components/v2/global/breadcrumbs';
import Column from '@root/components/v2/layout/columns/Column';
import ColumnsContainer from '@root/components/v2/layout/columns/ColumnsContainer';
import PageContainer from '@root/components/v2/layout/PageContainer';
import PageContent from '@root/components/v2/layout/PageContent';
import PageHeader from '@root/components/v2/layout/PageHeader';
import { Button } from '@root/components/v3/button';
import ContentCard from '@root/components/v3/content-card';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@root/components/v3/dialog';
import { useEnvironments, useSelectedEnvironments } from '@root/hooks/environments';
import { formatTimeFilter } from '@root/hooks/features';
import useTimeFilter from '@root/hooks/SelectTimeFilter.jsx';
import useSortData from '@root/hooks/useSortData';
import DismissPopup from '@root/pages/events/Table/DismissPopup';
import ResolvePopup from '@root/pages/events/Table/ResolvePopup';
import { useQuery as useQueryReact } from '@tanstack/react-query';
import isEmpty from 'lodash/isEmpty';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { SuppressedColumns } from './SuppressedColumns';

// timezone info
import { fetchuserPolicyData, fetchuserPolicyTableData } from '@root/containers/dashboard/action';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { ChevronRight, X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';

dayjs.extend(utc);
dayjs.extend(timezone);

const TIMEZONE = dayjs.tz.guess();

const BREADCRUMBS = [{ title: 'Kubernetes Live Action History' }];

const K8ActionHistory = () => {
  const dispatch = useDispatch();

  const { cloudProvider } = useCloudProvider();
  const { selectedEnvironments, selectedEnvironmentTags } = useSelectedEnvironments();
  const allEnvironments = useEnvironments();
  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1); // Changed to 0 for 0-based indexing
  const [searchTermSubmit, setSearchTermSubmit] = useState('');
  const [tableLength, setTableLength] = useState(0);
  const { sortData, handleSortModelChange } = useSortData();
  const [resolveDialogData, setResolveDialogData] = useState({});
  const [dismissDialogData, setDismissDialogData] = useState({});
  const [previousJustification, setPreviousJustification] = useState('');
  const [previousDismissDays, setPreviousDismissDays] = useState('0');
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const scan_permission = JSON.parse(localStorage.getItem('User Policy') || '[]');
  const scanButtonPolicy = useSelector(state => state.policyRes.data);
  const [isSelectAllEventDetails, setIsSelectAllEventDetails] = useState({});

  useEffect(() => {
    if (isEmpty(scanButtonPolicy)) {
      dispatch(fetchuserPolicyData);
      dispatch(fetchuserPolicyTableData);
    }
  }, [dispatch, scanButtonPolicy]);
  let editSuppressedEvents = false;
  // let deleteSuppressedEvents = false;

  const { timeFilter, timeRange } = useTimeFilter();

  const handleDelayedSearchTermSubmit = useCallback(() => {
    setSearchTermSubmit(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleDelayedSearchTermSubmit();
    }, 2000);

    return () => clearTimeout(delayDebounceFn);
  }, [handleDelayedSearchTermSubmit]);

  const environments = useMemo(() => {
    if (selectedEnvironments.length && cloudProvider !== 'all') {
      return selectedEnvironments.filter(environment => environment.cloudProvider === cloudProvider);
    } else if (cloudProvider === 'all') {
      return selectedEnvironments;
    }
    return allEnvironments;
  }, [selectedEnvironments, cloudProvider, allEnvironments]);

  scanButtonPolicy.filter(itm => {
    if (scan_permission.includes('All Permissions')) {
      editSuppressedEvents = true;
      // deleteSuppressedEvents = true;
    } else {
      if (itm.sub_menu_items === 'Edit Suppressed Event') {
        const temp = Object.keys(itm);
        scan_permission.map(itm2 => {
          if (temp.includes(itm2)) {
            editSuppressedEvents = itm[itm2] === 'False' ? false : true;
            // console.log(itm[itm2],"View Remediation( console, CLI, OCR)")
          }
        });
        // if (itm.read_only === 'True') {
        //   editSuppressedEvents = true;
        // } else {
        //   editSuppressedEvents = false;
        // }
      }
      if (itm.sub_menu_items === 'Delete Suppressed Event') {
        // if (itm.read_only === 'True') {
        //   deleteSuppressedEvents = true;
        // } else {
        //   deleteSuppressedEvents = false;
        // }
        const temp = Object.keys(itm);
        scan_permission.map(itm2 => {
          if (temp.includes(itm2)) {
            // deleteSuppressedEvents = itm[itm2] === 'False' ? false : true;
            // console.log(itm[itm2],"View Remediation( console, CLI, OCR)")
          }
        });
      }
    }
  });

  const {
    data: actionHistoryEvents,
    isFetching: isFetchingJustifiedEvents,
    error: actionHistoryError,
    refetch: refetchJustifiedEvents,
  } = useQueryReact(
    ['get_action_history', searchTermSubmit, page, pageSize, timeFilter, environments],
    () =>
      agent.Kubernetes.get_action_history({
        environments: environments?.map(env => env.id),
        clusters: [],
        date_filter: formatTimeFilter(timeFilter),
        timezone: TIMEZONE,
        page_number: page,
        rows_per_page: pageSize,
        search_query: searchTerm,
        sort: sortData,
      }),
    {
      staleTime: 0,
    },
  );

  useEffect(() => {
    setIsSelectAllEventDetails({
      to_date: timeRange.to.replaceAll('/', '-'),
      from_date: timeRange.from.replaceAll('/', '-'),
      timezone: TIMEZONE,
      scope: selectedEnvironmentTags,
      environments: environments.map(e => e.id),
      cloud_provider: cloudProvider,
      search_keyword: searchTerm,
    });
  }, [
    cloudProvider,
    environments,
    searchTerm,
    searchTermSubmit,
    selectedEnvironmentTags,
    timeRange.from,
    timeRange.to,
  ]);

  const _rows = useMemo(() => {
    return tableData?.map((row, indexe) => ({ ...row, id: indexe })) ?? [];
  }, [tableData]);

  useEffect(() => {
    setTableData(actionHistoryEvents?.data ?? []);
    setTableLength(actionHistoryEvents?.pagination?.total ?? 0);
  }, [actionHistoryEvents]); // Removed tableData from dependencies

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleModifyJustification = async row => {
    if (row.justification_status === 'dismiss') {
      const justificationTime = new Date(row.justification_endtime);
      const receivedTime = new Date(row.justification_received_time);
      // Calculate difference in milliseconds
      const diffInMs = justificationTime - receivedTime;

      // Convert to days
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
      setDismissDialogData(row);
      setPreviousJustification(row.justification_reason);
      setPreviousDismissDays(Math.floor(diffInDays));
    } else {
      setResolveDialogData(row);
      setPreviousJustification(row.justification_reason);
    }
  };

  const [hoverRowEdit, setHoverRowEdit] = useState('');
  // const [hoverRowDelete, setHoverRowDelete] = useState('');

  const suppressedActionHistory = useMemo(() => {
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {actionHistoryError ? (
          <NoData message="Error fetching action history. Please try again." />
        ) : (
          <MuiTable
            paginationMode="server"
            isDynamicHeight
            rowHeight={50}
            LoaderState={isFetchingJustifiedEvents}
            columns={SuppressedColumns(
              handleModifyJustification,
              hoverRowEdit,
              setHoverRowEdit,
              // hoverRowDelete,
              // setHoverRowDelete,
              // deleteSuppressedEvents,
              editSuppressedEvents,
            )}
            rows={_rows}
            onPageChange={newPage => setPage(newPage)}
            total_size={tableLength}
            components={{
              DetailPanelExpandIcon: () => <ChevronRight size={16} />,
              DetailPanelCollapseIcon: () => <ExpandMore size={16} />,
            }}
            handleSortModelChange={handleSortModelChange}
            pageSize={pageSize}
            page={page}
            noDataMessage={'No Events present!'}
            onPageSizeChange={setPageSize}
          />
        )}
      </div>
    );
  }, [
    isFetchingJustifiedEvents,
    actionHistoryError,
    page,
    pageSize,
    tableLength,
    handleModifyJustification,
    hoverRowEdit,
    setHoverRowEdit,
    _rows,
    setPage,
    setPageSize,
    handleSortModelChange,
    editSuppressedEvents,
  ]);

  return (
    <PageContainer className={'CloudEvents__Container'}>
      <PageHeader title={<Breadcrumbs breadcrumbs={BREADCRUMBS} />}></PageHeader>
      {/* <CloudProviderBar showTab={false} /> */}
      <PageContent>
        {cloudProvider !== 'azure' ? (
          <>
            <Column>
              <ColumnsContainer columnSeparation={'15px'} marginBottom={'15px'}>
                <Column>
                  <ColumnsContainer columnSeparation={'10px'} marginBottom={'10px'}>
                    <Column>
                      <HeaderBarNew
                        marginBottom={'5px'}
                        title={''}
                        searchBar
                        searchBarValue={searchTerm}
                        setSearchTerm={setSearchTerm}
                        searchBarOnChange={e => setSearchTerm(e.target.value)}
                      />
                    </Column>
                  </ColumnsContainer>
                  <ColumnsContainer columnSeparation={'5px'}>
                    <Column>{suppressedActionHistory}</Column>
                  </ColumnsContainer>
                </Column>
              </ColumnsContainer>
            </Column>
          </>
        ) : (
          <ContentCard>
            <NoData message="Action history not supported for Azure" height={'700px'} />
          </ContentCard>
        )}
      </PageContent>

      <Dialog open={!isEmpty(resolveDialogData)} onOpenChange={() => setResolveDialogData({})}>
        <DialogContent className="max-w-[720px]">
          <ResolvePopup
            environments={environments.map(e => e.id)}
            onClose={() => setResolveDialogData({})}
            resolveDialogData={resolveDialogData}
            previousJustification={previousJustification}
            setResolveDialogData={setResolveDialogData}
            refetchJustifiedEvents={refetchJustifiedEvents}
            isSelectAllEventDetails={isSelectAllEventDetails}
            from="k8"
          />
        </DialogContent>
      </Dialog>

      <Dialog open={!isEmpty(dismissDialogData)} onOpenChange={() => setDismissDialogData({})}>
        <DialogContent className="max-w-[720px]">
          <DismissPopup
            onClose={() => setDismissDialogData({})}
            environments={environments.map(e => e.id)}
            dismissDialogData={dismissDialogData}
            setOpenSuccessPopup={setOpenSuccessPopup}
            previousDismissDays={previousDismissDays}
            previousJustification={previousJustification}
            setDismissDialogData={setDismissDialogData}
            isSelectAllEventDetails={isSelectAllEventDetails}
            refetchJustifiedEvents={refetchJustifiedEvents}
            from="k8"
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openSuccessPopup} onOpenChange={setOpenSuccessPopup}>
        <DialogContent className="max-w-[50rem]">
          <DialogHeader>
            <DialogTitle className="text-[#1a202c] text-sm font-semibold">Success</DialogTitle>
            <DialogClose className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </DialogClose>
          </DialogHeader>

          <div className="flex items-center gap-2 py-4">
            <img src={successCheckMark} className="w-6 h-6" alt="Success" />
            <p className="text-[15px] font-manrope text-[#1D8661] font-medium">
              Please run a manual scan to see the updated security score
            </p>
          </div>

          <DialogFooter>
            <Button
              data-testid="click-k8s-pages-actionhistory-done-355"
              data-clickable="true"
              onClick={() => setOpenSuccessPopup(false)}>
              Done
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </PageContainer>
  );
};

export default K8ActionHistory;
